import { Drawer } from 'rsuite';
import { RsButton } from 'components/Rsuite/Button';

import { ProductHome } from './components/ProductHome';
import { useCampaignStore } from 'store/campaignStore';
import { useOrderStore } from 'store/orderStore';
import styles from './productManager.module.scss';
import { FC } from 'react';

interface ProductManagerProps {
  singleSelect?: boolean;
  enableCreateProductNativeCreative?: boolean;
  availableProducts?: number;
  showImportButton?: boolean;
  closeProductManager?: () => void;
}

const ProductManager: FC<ProductManagerProps> = ({
  singleSelect = false,
  enableCreateProductNativeCreative = false,
  availableProducts,
  showImportButton = false,
  closeProductManager,
}) => {
  const { showProductManager, openProductManager } = useCampaignStore();
  return (
    <Drawer
      placement={'right'}
      size={1260}
      open={showProductManager}
      onClose={async () => {
        if (closeProductManager) {
          await closeProductManager();
        } else {
          openProductManager(false);
        }
      }}
    >
      <Drawer.Body className='p-0'>
        <ProductHome
          defaultFilters={{
            advertiser: useOrderStore.getState().order.advertiserId,
          }}
          enableCreateProductNativeCreative={enableCreateProductNativeCreative}
          singleSelect={singleSelect}
          limitSelect={true}
          availableProducts={availableProducts}
          showImportButton={showImportButton}
        />
        <div className={styles.buttonArea}>
          <RsButton
            appearance='primary'
            onClick={async () => {
              if (closeProductManager) {
                await closeProductManager();
              } else {
                openProductManager(false);
              }
            }}
          >
            完成
          </RsButton>
        </div>
      </Drawer.Body>
    </Drawer>
  );
};

export default ProductManager;
